import { mount } from "@vue/test-utils";
import CuitField from "@/components/core/CuitField";

describe("CuitField test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(CuitField);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component CuitField", () => {
    expect(wrapper).toBeDefined();
  });
});
